import TrustPilotScript from './TrustPilotScript'

export default TrustPilotScript
